import { Box, CircularProgress, Typography } from "@mui/material";
import {
  useFoundationColorTokens,
  useTypography,
} from "@surya-digital/leo-reactjs-material-ui";
import React from "react";
import { isBrowserLightMode } from "@pulse/shared-components";

const PROGRESS_SIZE = 48;
const PROGRESS_THICKNESS = 4;

interface ChatSurveyProgressProps {
  value: number;
}

export const ChatSurveyProgress = ({
  value,
}: ChatSurveyProgressProps): React.ReactElement => {
  const tokens = useFoundationColorTokens();
  const typography = useTypography();

  return (
    <Box sx={{ position: "relative", display: "inline-flex" }}>
      <CircularProgress
        variant="determinate"
        sx={{
          color: isBrowserLightMode() ? tokens.borderSubtle : tokens.border,
        }}
        size={PROGRESS_SIZE}
        thickness={PROGRESS_THICKNESS}
        value={100}
      />
      <CircularProgress
        variant="determinate"
        value={value}
        sx={{
          color: tokens.borderHighEmphasis,
          position: "absolute",
        }}
        size={PROGRESS_SIZE}
        thickness={PROGRESS_THICKNESS}
      />
      <Box
        sx={{
          inset: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography
          sx={{
            ...typography.b3,
            color: tokens.label,
          }}
        >{`${Math.round(value)}%`}</Typography>
      </Box>
    </Box>
  );
};
